import React from "react";
import ReactModal from "react-modal";
import Loader from "../../../common/loader";
import { toast } from "react-toastify";
import { responseHandler, errorHandler } from "../../../requests/axios";
import Select from "../../../common/select";

// add more defaults as needed
const defaultFields = {
  text: "",
  password: "",
};

function TextField({ field, onChange }) {
  return (
    <div className="form-field">
      <label>{field.label}</label>
      <input
        type={field.type}
        name={field.name}
        onChange={(e) => onChange(field.name, e.target.value)}
      />
      {/* {errors.hasOwnProperty("email") ? (
        <div className="form-field__error">{errors.email}</div>
      ) : null} */}
    </div>
  );
}

function SelectField({ field, onChange }) {
  return (
    <div className="form-field">
      <label>{field.label}</label>
      <Select
        options={field.options}
        onChange={(option) => onChange(field.name, option.value)}
        name={field.name}
      />
    </div>
  );
}

// Handle success in parent component
export default function GenericAddDialog({
  onSubmit,
  onSuccess,
  onClose,
  isOpen,
  title,
  fields,
  submitText = "Add",
  cancelText = "Cancel",
  successMessage = "",
  errorMessage = "",
}) {
  const [isLoading, setLoading] = React.useState(false);
  const [form, setForm] = React.useState(createFormFromFields());

  const handleChange = React.useCallback((key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  function createFormFromFields() {
    if (!fields.length) {
      return {};
    }

    let newForm = {};
    fields.forEach((field) => {
      newForm[field.name] = defaultFields[field.type];
    });

    return newForm;
  }

  function validateForm() {
    let passes = true;

    fields.forEach((field) => {
      if (field.required && !form[field.name]) {
        passes = false;
      }
    });

    // @TODO add more validation rules

    return passes;
  }

  function beginSubmit() {
    setLoading(true);

    if (!validateForm()) {
      toast.error("Validation Error");
      setLoading(false);
      return;
    }

    onSubmit(form)
      .then(
        responseHandler(() => {
          toast.success(successMessage);
          onSuccess();
          onClose();
        })
      )
      .catch(
        errorHandler((e) => {
          console.error(e);
          toast.error(errorMessage);
        })
      )
      .finally(() => setLoading(false));
  }

  function getFieldComponent(field, onChange) {
    switch (field.type) {
      case "text":
      case "password":
        return <TextField field={field} onChange={onChange} />;
      case "select":
        return <SelectField field={field} onChange={onChange} />;
      default:
        return;
    }
  }

  return (
    <ReactModal isOpen={isOpen} onRequestClose={onClose} ariaHideApp={false}>
      <div className="v-react-modal__inner modal-width">
        <div className="v-react-modal__heading">{title}</div>
        <div className="v-react-modal__body">
          {fields.map((field) => getFieldComponent(field, handleChange))}
        </div>
        <div className="v-react-modal__footer" style={{ marginTop: "4px" }}>
          {isLoading ? (
            <Loader width={45} height={45} />
          ) : (
            <React.Fragment>
              <button className="btn btn--inverse-primary" onClick={onClose}>
                {cancelText}
              </button>
              <button className="btn btn--primary" onClick={beginSubmit}>
                {submitText}
              </button>
            </React.Fragment>
          )}
        </div>
      </div>
    </ReactModal>
  );
}
